export default __webpack_public_path__ + "static/media/iStock-1167047685.ca5f5ac6.jpg";